module.exports = __webpack_public_path__ + "img/myposition_am_케빈 더 브라위너.bda96b9b.png";